import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/auth';

const ParentAbsences = () => {
  const { childId } = useParams();
  const navigate = useNavigate();
  const [absences, setAbsences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (childId) fetchAbsences();
  }, [childId]);

  const fetchAbsences = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');
      const res = await api.get(`/parent/children/${childId}/absences-list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAbsences(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur:', err);
      setError(err.response?.data?.error || 'Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (abs) => {
    if (abs.is_justified) return <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">✅ Justifiée</span>;
    if (abs.justification_status === 'pending') return <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-700">⏳ En attente</span>;
    if (abs.justification_status === 'rejected') return <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700">❌ Refusée</span>;
    return <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">🔴 Non justifiée</span>;
  };

  const getTypeBadge = (type) => {
    switch (type) {
      case 'absence':
        return <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700">🚨 Absence</span>;
      case 'retard':
        return <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">⏰ Retard</span>;
      case 'renvoye':
        return <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700">🚪 Renvoyé</span>;
      default:
        return <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">{type}</span>;
    }
  };

  if (loading) return <div className="p-6 text-center text-gray-500">Chargement...</div>;
  if (error) return <div className="p-6 bg-red-50 border border-red-200 rounded-lg text-red-700">{error}</div>;

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <button onClick={() => navigate('/parent/children')} className="text-sm text-gray-500 hover:text-[#F39C12] mb-2">← Retour aux enfants</button>
        <h1 className="text-3xl font-bold text-[#0A0A0A]">📅 Absences</h1>
        <p className="text-gray-500 mt-1">Suivi des absences, retards et renvois</p>
      </div>

      {absences.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center">
          <p className="text-5xl mb-3">🎉</p>
          <p className="text-lg font-bold text-[#0A0A0A] mb-2">Aucune absence</p>
          <p className="text-sm text-gray-500">Aucune absence ni retard enregistré.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600">Date / Heure</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600">Type</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600">Durée</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600">Statut</th>
                  <th className="text-left py-3 px-4 text-xs font-semibold text-gray-600">Motif</th>
                </tr>
              </thead>
              <tbody>
                {absences.map((abs) => (
                  <tr key={abs.id} className="border-t hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium">
                      {abs.date} {abs.time && <span className="text-gray-400 text-xs ml-1">à {abs.time}</span>}
                    </td>
                    <td className="py-3 px-4">{getTypeBadge(abs.type)}</td>
                    <td className="py-3 px-4 text-sm">{abs.duration_minutes ? `${abs.duration_minutes} min` : '-'}</td>
                    <td className="py-3 px-4">{getStatusBadge(abs)}</td>
                    <td className="py-3 px-4 text-sm text-gray-500">{abs.reason || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParentAbsences;